module.exports = require("./lib/_stream_transform.js")



//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/readable-stream/transform.js
// module id = ../../../../readable-stream/transform.js
// module chunks = 3